import CalculationDropDownField from "@/components/Calculator/Components/CalculationDropDownField/calculationDropDownField.component";
import CalculationField from "@/components/Calculator/Components/CalculationField/calculationField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { DamImage } from "@/utils/dam.utils";

import { CalculatorImage } from "../../Components/CalculatorImage/calculatorImage.component";
import { useGravelCalculationContext } from "../gravelCalculation";
import { Weights } from "../gravelCalculation.config";

const CalculationComponent = () => {
    const { t } = useGranite();

    const {
        length,
        width,
        thickness,
        weight,
        setLength,
        setWidth,
        setThickness,
        setWeight
    } = useGravelCalculationContext();

    return (
        <div className={"mt-4"}>
            <Row>
                <Col md={6}>
                    <h3 className="d-sm-block">
                        {t("calculator.gravelCalculator.gravelMeasurements")}
                    </h3>
                    <CalculationField
                        classNames="pl-0"
                        md={6}
                        name={"gravelLength"}
                        dimension={"length"}
                        unit={"m"}
                        setCalculationValue={(_, value) => setLength(value)}
                        value={length}
                    />
                    <CalculationField
                        classNames="pl-0"
                        md={6}
                        name={"gravelWidth"}
                        dimension={"width"}
                        unit={"m"}
                        setCalculationValue={(_, value) => setWidth(value)}
                        value={width}
                    />

                    <CalculationField
                        classNames="pl-0"
                        md={6}
                        name={"gravelThickness"}
                        dimension={"thickness"}
                        unit={"m"}
                        setCalculationValue={(_, value) => setThickness(value)}
                        value={thickness}
                    />
                    <CalculationDropDownField
                        name={"gravelWeight"}
                        dimension={"weight"}
                        values={Weights.map((w) => ({
                            value: w.toFixed(0),
                            label: t(
                                "calculator.gravelCalculator.weight.label",
                                w
                            )
                        }))}
                        setCalculationValue={(_, value) => setWeight(value)}
                        value={weight}
                        classNames="pl-0"
                    />
                </Col>
                <Col md={6}>
                    <CalculatorImage
                        size={"large"}
                        src={DamImage.calculator.gravel()}
                        alt={"calculator-gravel.jpg"}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default CalculationComponent;
